import { API_AUTH, setTokenGlobal } from "./common";
import { Cookies } from "react-cookie";
import { getDomain } from "utils/utils";

var urlNew = getDomain();
const cookies = new Cookies();
var token = cookies.get("userTokenDaiLy");
if (typeof token != "undefined" && token.length > 6) {
  token = token.substring(6);
  setTokenGlobal(token, urlNew);
}
export default {
  getDanhSachNhapHang: (params) =>
    API_AUTH.get("nhaphang/getDanhSachNhapHang", params),
  saveNhapHang: (params) => API_AUTH.post("nhaphang/saveDonHang", params),
  kiemTraTrungDon: (params) =>
    API_AUTH.post("nhaphang/kiemTraTrungDon", params),
  kiemTraSuaDon: (params) => API_AUTH.post("nhaphang/kiemTraSuaDon", params),
  kiemTraSuaDonById: (params) =>
    API_AUTH.get(
      "nhaphang/kiemTraSuaDonById?ImportOrderID=" + params.ImportOrderID
    ),
  boTruKhoDonHang: (params) =>
    API_AUTH.get(
      "nhaphang/boTruKhoDonNhap?ImportOrderID=" + params.ImportOrderID
    ),

  getDonHangById: (params) => API_AUTH.get("nhaphang/getDonHangById", params),
  deleteNhapHang: (params) =>
    API_AUTH.post(
      "nhaphang/deleteNhapHang?ImportOrderID=" +
      params.ImportOrderID +
      "&sUserName=" +
      params.sUserName
    ),
  getDanhSachNhapHangPrint: (params) =>
    API_AUTH.get("nhaphang/getDanhSachNhapHangPrint", params),
  getTongNhapHangByBranch: (params) =>
    API_AUTH.get("nhaphang/getTongNhapHangByBranch", params),
  chiTietMauInNhapHang: (id) => {
    return API_AUTH.get(`nhaphang/printNhapHangById?id=${id}`, {});
  },
  chiTietMauInNhapHangGct: (id) => {
    return API_AUTH.get(`nhaphang/printNhapHangGctById?id=${id}`, {});
  },
  listNguoiTao: (iBranch) => {
    return API_AUTH.get(`users/getAllUser?iBranch=${iBranch}`, {});
  },
  saveThanhToanNhapHang: (
    ImportOrderID,
    LoaiGiaoDich,
    SoTienThanhToan,
    GhiChu,
    UserName
  ) =>
    API_AUTH.post(
      "nhaphang/SaveThanhToanNhapHang?ImportOrderID=" +
      ImportOrderID +
      "&loaiGiaoDich=" +
      LoaiGiaoDich +
      "&soTienThanhToan=" +
      SoTienThanhToan +
      "&ghichu=" +
      GhiChu +
      "&userName=" +
      UserName
    ),
  // Bao cao
  getGroupCus: (params) => API_AUTH.get("NhomKhachHang/DanhSachNhomKH", params),
  getGroupOptSys: () => API_AUTH.get("bcnhaphang/getAllOptSys"),
  getNhapHangSanPham: (params) =>
    API_AUTH.get("/bcnhaphang/getnhaphangsanpham", params),
  getNhapHangSanPhamChiTiet: (params) =>
    API_AUTH.get("/bcnhaphang/getchitietnhaphangsanpham", params),
  getMauInNhapHangSanPham: (params) =>
    API_AUTH.get("/bcnhaphang/getmauinnhaphangsanpham", params),
  getMauInNhapHangSanPhamDanhSach: (params) =>
    API_AUTH.get("/bcnhaphang/getmauinnhaphangsanphamdanhsach", params),
};
